import React from 'react';
import BasePage from '../../../core/page/BasePage';
import BaseFilter from '../../../core/page/components/baseFilter/BaseFilter';
import SituacaoAvaliacaoService from '../../../service/SituacaoAvaliacaoService';
import AnaliseNegocialService from '../../../service/AnaliseNegocialService';
import RotuloSeplag from '../../../components/rotuloSeplag/RotuloSeplag';
import { InputText } from 'primereact/inputtext';
import { inputsAnaliseNegocial } from './PageInputs';
import Pages from '../../../config/Pages';
import { useOrgao } from '../Utils';
import AfterActionsButtons from './components/AfterActionsButtons';
import InputDropDown from '../../../core/components/inputs/inputDropDown/InputDropDown';
import AutoCompleteDropDown from '../../../core/components/inputs/AutoCompleteDropDown';
import orgaoIntegracaoService from '../../../service/integracao/OrgaoIntegracaoService';
import builder from '@rsql/builder';
import pessoaIntegracaoService from '../../../service/integracao/PessoaIntegracaoService';

function AnaliseNegocial() {
    const orgaoUsuarioLogado = useOrgao();
    const Inputs = ({ formik }) => (
        <>
            <RotuloSeplag nome="Órgao/Entidade" cols="12 3 4">
                <AutoCompleteDropDown
                    name="orgao"
                    formik={formik}
                    field={'descOrgao'}
                    disabled={orgaoUsuarioLogado?.siglOrgao !== 'SEPLAG'}
                    service={orgaoIntegracaoService.autoComplete.bind(orgaoIntegracaoService)}
                />
            </RotuloSeplag>
            <RotuloSeplag nome="Usuário de Cadastro da Proposta" cols="12 3 4">
                <InputText
                    name="respCadastro"
                    value={formik.values.respCadastro}
                    onChange={formik.handleChange}
                />
            </RotuloSeplag>
            <RotuloSeplag nome="Analista Negocial" cols="12 3 4">
                <AutoCompleteDropDown
                    name="responsavelAnalise"
                    formik={formik}
                    field={'nomePessoa'}
                    service={pessoaIntegracaoService.autoComplete.bind(pessoaIntegracaoService)}
                />
            </RotuloSeplag>
            <RotuloSeplag nome="Nº da Proposta" cols="12 3 4">
                <InputText
                    name="numeroProposta"
                    value={formik.values.numeroProposta}
                    onChange={formik.handleChange}
                    keyfilter="int"
                />
            </RotuloSeplag>
            <RotuloSeplag nome="Nome do Indicador" cols="12 3 4">
                <InputText
                    name="nomeDoIndicador"
                    value={formik.values?.nomeDoIndicador}
                    onChange={formik.handleChange}
                />
            </RotuloSeplag>
            <RotuloSeplag nome="Situação da Análise" cols="12 3 4">
                <InputDropDown
                    name="situacaoAvaliacao"
                    formik={formik}
                    callbackSetList={SituacaoAvaliacaoService.list.bind(SituacaoAvaliacaoService)}
                    optionLabel={'descSituacaoAvaliacao'}
                    optionValue={'codgSituacaoAvaliacao'}
                />
            </RotuloSeplag>
            <RotuloSeplag nome="Parecer Negocial" cols="12 3 4">
                <InputDropDown
                    name="parecer"
                    formik={formik}
                    staticList={[
                        { parecer: true, descricao: 'APTO' },
                        { parecer: false, descricao: 'INAPTO' },
                    ]}
                    optionValue={'parecer'}
                />
            </RotuloSeplag>
        </>
    );

    return (
        <BasePage
            service={AnaliseNegocialService}
            page={{
                pageUrls: Pages.sei.analiseNegocial.url.list,
                pageName: Pages.sei.analiseNegocial.title,
            }}
            initialValues={inputsAnaliseNegocial.filter((input) => input?.table?.use ?? false)}
            enableAdicionar={false}
            enableExcluir={false}
            enableAlterar={false}
            enableVisualizar={false}
            enableEditar={false}
            addAfterActions={(dados) => <AfterActionsButtons dados={dados} />}
        >
            <BaseFilter
                initialValues={inputsAnaliseNegocial.filter((input) => input?.filter?.use ?? false)}
                customFilter={{
                    orgao: ({ nameUse, original }) =>
                        builder.comparison(nameUse, '==', original?.idenOrgao),
                    responsavelAnalise: ({ nameUse, original }) =>
                        builder.comparison(nameUse, '==', original?.idenPessoa),
                }}
                prepareInitialValues={async (dados) => ({ ...dados, orgao: orgaoUsuarioLogado })}
                noEmptyInputsOnClear={orgaoUsuarioLogado?.siglOrgao === 'SEPLAG'}
            >
                <Inputs />
            </BaseFilter>
        </BasePage>
    );
}

export default AnaliseNegocial;
